<template>
    <div class="se-autocomplete">
        <div class="autocomplete-input-outer">
            <template v-if="loginLog.length > 0">
                <input type="text" :value="value" @focus="getQueryString1" @input="getQueryString1" :placeholder="placeholder"/>
            </template>
            <template v-else>
                <input type="text" :value="value" @focus="getQueryString" @input="getQueryString" :placeholder="placeholder"/>
            </template>
            <img src="@/assets/scanning.png" class="scanning" @click="scann" v-if="isShow"/>
        </div>
        <div class="autocomplete-list-outer" v-if="loginLog.length > 0 && xinShow">
            <ul>
                <template  v-for="(item, index) in loginLog" >
                    <li :key="index"  v-if="index < 3">
                        <span  @click="selectItem(item)">{{ item }} </span>
                        <van-icon name="delete" @click.stop="del(item)"/>
                    </li>
                    <li :key="index" v-if="index >= 3 && moreFlag">
                        <span  @click="selectItem(item)">{{ item }} </span>
                        <van-icon name="delete" @click.stop="del(item)"/>
                    </li>
                </template>
            </ul>
            <template v-if="loginLog.length > 3 && !moreFlag" >
                <div class="more" @click="hanldeMore">查看更多</div>
            </template>
        </div>
        <template v-else>
            <div class="autocomplete-list-outer" v-if="showList">
                <ul>
                    <li v-for="(item, index) in list" :key="index">
                        <span  @click="selectItem(item)">{{ item }} </span>
                        <van-icon name="delete" @click.stop="del(item)"/>
                    </li>
                </ul>
            </div>
        </template>
       
    </div>
</template>
<script>
import { wxRequest } from "@/api/user.js";
import { Toast } from "vant";
export default {
    name: 'SeAutocomplete',
    props:{
        fetchsuggestions: {
            type: Function,
            required: true
        },
        placeholder: {
            type: String
        },
        value: {
            type: String
        },
        loginLog:{
            type:Array,
            default:()=>{
                return []
            }
        },
        isShow:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            showList: false,
            moreFlag:false,
            xinShow:false,
            list: []
        }
    },
    watch:{
        loginLog:{
            handler(val) {
                if(val.length > 0){
                    this.xinShow = true
                    if(this.value){
                        this.xinShow = false
                    }
                }
            },
            immediate: true
        },
        value:{
            handler(val){
                this.xinShow = false
                if(!val && this.loginLog.length > 0){
                    this.xinShow = true
                }
            },
            immediate:true
        }
    },
    created() {      
    },
    methods: {
        init(){
            wxRequest("/sim/get/openid", {isOpenid:1,code: localStorage.getItem('wxOpenId')}, "get").then((res) => {
                this.list = res.data.data.cardList
                res.data.data.cardList.length > 0 ? this.showList = true : this.showList = false
            })
        },
        hanldeMore(){
            this.$nextTick(() => {
                this.moreFlag = true
                this.$forceUpdate()
            })
        },
        selectItem(item){
            this.$emit('select', item)
            this.showList = false 
            this.xinShow = false
        },
        getQueryString1($event){
            this.$emit('input', $event.target.value);
        },
        getQueryString($event){
            this.$emit('input', $event.target.value);
            this.$nextTick(() => {
                this.fetchsuggestions(this.value, (result) => {
                    this.list = result;
                    result.length > 0 ? this.showList = true : this.showList = false
                })
            })
        },
        del(data){
            wxRequest("sim/delete/wx/iccid", {iccid:data}, "post").then((res) => {
                if (res.data.code == 200) {
                    Toast.success("删除成功,刷新页面即可");
                  // this.init()
                } else {
                    Toast.error(res.data.message);
                }
            })
        },
        createFilter(queryString) {
            return (listAll) => {
                return listAll.indexOf(queryString) == 0;
            };
        },
        scann(){
            this.$router.push({path: '/user/qrcode-scan' });
        }
    }
}
</script>
<style lang="less" scoped>
.se-autocomplete {
    width: 100%;
    position: relative;
    .autocomplete-input-outer {
        position:relative;
        .scanning{
            position: absolute;
            right: 16px;
            top: 10px; 
        }
    }
    .autocomplete-list-outer{
        position: absolute;
        top: 53px;
        left: 0;
        width: 100%;
        z-index: 10000;
        background: #fff;
        max-height:120px;
        overflow: scroll;
        border-radius:10px;
        box-sizing: border-box;
        ul {            
            li {
                height: 40px;
                line-height: 40px;
                text-align: center;
                padding: 0 10px;
                /* display: flex;
                align-items: center;
                justify-content: space-between; */
                &:hover {
                    background: #f5f7fa;
                }
                .van-icon-delete{
                    /* color:#FF7F52;
                    font-size: 20px; */
                }
            }
        }
        .more{
            height:44px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            text-align: center;
            background: #F8F8F8;
            color: #1870B8;
            line-height:44px;
        }
    }
}
</style>
